import React from 'react';
import { GLOBAL } from '../../utils/constant/global';
import './EmptyData.scss';

const { NO_DATA } = GLOBAL;

/**
 * EmptyData — standard "no data" empty state used app-wide (DataTable
 * noDataComponent, list/section empties). Clean window-card illustration
 * with floating accents.
 *
 * @param {string}  [title]    main label (defaults to GLOBAL.NO_DATA)
 * @param {string}  [subtitle] optional helper line
 * @param {boolean} [compact]  tighter vertical padding
 */
export default function EmptyData({ title, subtitle, compact = false }) {
  return (
    <div className={`hrx-empty${compact ? ' hrx-empty--compact' : ''}`} role="status">
      <div className="hrx-empty__art" aria-hidden="true">
        {/* floating accents */}
        <span className="hrx-empty__spark hrx-empty__spark--1">×</span>
        <span className="hrx-empty__spark hrx-empty__spark--2">×</span>
        <span className="hrx-empty__dot hrx-empty__dot--1" />
        <span className="hrx-empty__dot hrx-empty__dot--2" />
        <span className="hrx-empty__dot hrx-empty__dot--3" />
        <span className="hrx-empty__tri" />

        {/* window-card illustration */}
        <svg
          className="hrx-empty__card"
          width="120"
          height="92"
          viewBox="0 0 120 92"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="6" y="10" width="108" height="74" rx="10" fill="#eef1f7" />
          <rect x="6" y="10" width="108" height="74" rx="10" stroke="#dde2ec" strokeWidth="1.5" />
          {/* title bar */}
          <path d="M6 20a10 10 0 0 1 10-10h88a10 10 0 0 1 10 10v6H6v-6z" fill="#e2e7f0" />
          <circle cx="18" cy="18" r="2.5" fill="#c4ccdb" />
          <circle cx="27" cy="18" r="2.5" fill="#c4ccdb" />
          <circle cx="36" cy="18" r="2.5" fill="#c4ccdb" />
          {/* content lines */}
          <rect x="20" y="40" width="40" height="6" rx="3" fill="#cfd6e3" />
          <rect x="20" y="54" width="30" height="6" rx="3" fill="#dbe0ea" />
          <rect x="20" y="68" width="22" height="6" rx="3" fill="#dbe0ea" />
          {/* content block */}
          <rect x="72" y="40" width="28" height="34" rx="6" fill="#d7dde8" />
        </svg>
      </div>

      <p className="hrx-empty__title">{title || NO_DATA}</p>
      {subtitle ? <p className="hrx-empty__subtitle">{subtitle}</p> : null}
    </div>
  );
}
